(function () {
  var RELEASED_CLASS = 'product__column-sticky--released';

  function initStickyMedia(media) {
    var product = media.closest('.product');
    if (!product) return;
    var anchor = product.querySelector('[data-block-type="buy_buttons"]');
    if (!anchor) return;

    var topOffset = parseFloat(getComputedStyle(media).top) || 0;

    function update() {
      var anchorBottom = anchor.getBoundingClientRect().bottom;
      media.classList.toggle(RELEASED_CLASS, anchorBottom <= topOffset);
    }

    // Not throttled via requestAnimationFrame on purpose: rAF is paused while
    // the tab/document is hidden, which would permanently stall a ticking
    // flag. This handler is cheap (one rect read + one classList toggle), so
    // running it on every scroll/resize event directly is fine.
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  document.querySelectorAll('.product__media-wrapper.product__column-sticky').forEach(initStickyMedia);
})();
